export default "__VITE_ASSET__DPwCxBWy__"